import { Box, Button, Modal, Textarea } from "@mantine/core";

import { useState } from "react";

export default function JustificationModal({
  isOpen,
  onClose,
  handleChange
}: {
  isOpen: boolean;
  handleChange: (data: string) => void;
  onClose: () => void;
}) {
  const [justification, setJustification] = useState("");

  const closeModal = () => {
    setJustification("");
    onClose();
  };

  const handleSubmit = () => {
    handleChange(justification);
  };

  return (
    <Modal
      w="45%"
      size={450}
      title="Justificación"
      opened={isOpen}
      onClose={closeModal}
      data-testid="justificationmodal-modal"
    >
      <Box
        className="flex flex-column justify-center"
        mb={"sm"}
        data-testid="justificationmodal-content"
      >
        <Textarea
          placeholder="Escribir..."
          autoFocus
          data-testid="justificationmodal-textarea"
          value={justification}
          onChange={({ target }) => {
            setJustification(target.value);
          }}
          rows={5}
        />
      </Box>
      <Box className="flex justify-end gap-3" pt={"sm"} data-testid="justificationmodal-actions">
        <Button
          variant="outline"
          data-testid="justificationmodal-cancel-button"
          onClick={closeModal}
        >
          Cancelar
        </Button>
        <Button
          variant="filled"
          data-testid="justificationmodal-accept-button"
          onClick={handleSubmit}
        >
          Aceptar
        </Button>
      </Box>
    </Modal>
  );
}
